module.exports = __webpack_public_path__ + "img/point.104330f2.svg";